namespace GeniuzPOS.InventoryReport {
    export class IcReport05Columns {
        static columnsKey = 'InventoryReport.IcReport05';
    }
}
